import { ApartmentDto } from "@/api/models/coverage.model";
import whiteListActions from "./whiteListActions";

const saveApartment = ({ commit }: any, apartment: ApartmentDto) => {
	commit("setApartment", apartment);
};

export default {
	saveApartment,
	...whiteListActions
};
